// @flow
export const NUX_PICKER = 'nux_picker';
export const SIGNUP_TIME_COOKIE_EXPIRATION = 180000;
export const DEFAULT_NUM_TO_FOLLOW = 5;
export const RENUX_NUM_TO_FOLLOW = 1;
export const DEFAULT_NUM_TO_PRESELECT = 1;
export const MALE = 'male';
export const FEMALE = 'female';
export const CUSTOM = 'custom';
export const GENDER = 'gender';
export const UNSPECIFIED = 'unspecified';

export const FOLLOW_URSS_TOPICS = 1;

export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_COUNTRY = 'US';

export const NUX_BROWSER_EXT_INSTALLLED_CHECK_DELAY = 175; // hardcoded by @kdavison. Ping for questions.

export const NUM_OF_PINS_PROFILE_HOVER_STATES = 4;
export const PROFILE_HOVER_STATES_HIDE_DELAY = 500;

export const NUMBER_SELECTED_AT_BOTTOM_THRESHOLD = 1;

export const NUX_GENDER_STEP_STATUS = 'NUX_GENDER_STEP_STATUS';
export const NUX_COUNTRY_LOCALE_STEP_STATUS = 'NUX_COUNTRY_LOCALE_STEP_STATUS';
export const NUX_LOCALE_STEP_STATUS = 'NUX_LOCALE_STEP_STATUS';
export const NUX_COUNTRY_STEP_STATUS = 'NUX_COUNTRY_STEP_STATUS';
export const NUX_TOPIC_PICKER_STEP_STATUS = 'NUX_TOPIC_PICKER_STEP_STATUS';
export const NUX_BROWSER_EXT_STEP_STATUS = 'NUX_BROWSER_EXT_STEP_STATUS';
export const NUX_LOADING_STEP_STATUS = 'NUX_LOADING_STEP_STATUS';
export const NUX_WELCOME_NAME_STEP_STATUS = 'NUX_WELCOME_NAME_STEP_STATUS';

export const SKIPPED = 0;
export const SHOWED = 1;
export const COMPLETED = 2;

export const MAX_HEADING_WIDTH = 700;

export const MIN_HF_STEP_WIDTH = 800;

export const GESTALT_HEADING_STYLES = {
  color: '#333',
  fontSize: '24px',
  fontWeight: '700',
  lineHeight: '28px',
  maxWidth: '640px',
};

export const GESTALT_SUBHEADING_STYLES = {
  color: '#333',
  fontSize: '23px',
  fontWeight: '400',
  lineHeight: '28px',
};

export const INLINE_GENDER_EDIT_STYLE = {
  border: 'none',
  outline: 'none',
  fontSize: '24px',
  fontWeight: 'bold',
  color: '#8e8e8e',
  height: '40px',
  width: '420px', // Takes almost entire width of modal
};

export const INLINE_GENDER_EDIT_STYLE_WITH_BUTTON = {
  ...INLINE_GENDER_EDIT_STYLE,
  width: '324px', // Width is smaller in order to fit a button next to it.
};

export const SLIM_WIDTH_HEADING_STYLES = {
  color: '#333',
  fontSize: '24px',
  fontWeight: '700',
  lineHeight: '28px',
  maxWidth: '488px',
};

export const SLIM_WIDTH_SUBHEADING_STYLES = {
  color: '#333',
  fontSize: '24px',
  fontWeight: '400',
  lineHeight: '28px',
  maxWidth: '488px',
};

export const MASONRY_CONSTS = {
  MWEB: {
    COLUMNS: 3,
    COLUMN_WIDTH: 106,
    GUTTER_WIDTH: 8,
    STYLES: { paddingTop: 16 },
  },
  DESKTOP: {
    COLUMNS: 5,
    COLUMN_WIDTH: 136,
    GUTTER_WIDTH: 14,
    STYLES: {},
  },
  FULLSCREEN_NUX_PICKER: {
    COLUMNS: 3,
    COLUMN_WIDTH: 236,
    GUTTER_WIDTH: 24,
    STYLES: { maxWidth: '1300px', margin: '0 auto' },
  },
};

export type NuxAnimationElement = {|
  height: number,
  isSmall: boolean,
  left: number,
  top: number,
  width: number,
|};

export type NuxStep = {
  moduleName: string,
  options?: {
    onStartApi?: number,
    websiteUrl?: string,
    hasWebsite?: boolean,
  },
  isCompleted?: boolean,
};

export type InterestObj = {|
  background_color: string,
  context_locale: ?string,
  id: string,
  images: {|
    '400x': {|
      height: number,
      url: string,
      width: number,
    |},
  |},
  is_followed: boolean,
  label: string,
  name: string,
  log_data: string,
  nux_category: string,
|};

export type CategoryObj = {|
  title: string,
  interests: Array<InterestObj>,
|};

// This is currently only used by Topic Education and StoryHomefeedGridEducationCard
// to adjust topic selections
// TODO(jhu) rename it to topic_only to differentiate from renux
export const SIMPLE_RENUX_DISPLAY_DATA = {
  is_renux: true,
  is_simple_renux: true,
  steps: [
    {
      moduleName: 'NuxPicker',
    },
    {
      moduleName: 'NuxEducationLoader',
    },
  ],
  can_exit: true,
  relaunchPlacement: false,
  sub_type: 'modal',
};

// Used for progressively showing background Pin images in NUX. Depending on NUX step, various indices of masonry
// are shown with grey gradient to create progressive loading effect. Indices already loaded from a previous step
// should always persist without an overlay gradient in following steps.
// (ie. index 7 is loaded in welcome so it's loaded in all steps after).
export const BACKGROUND_IMAGE_INDICES_FOR_NUX_STEP = {
  welcome: [0, 7, 14, 20],
  gender: [0, 2, 7, 10, 14, 17, 20, 26, 28],
  locale: [0, 2, 5, 7, 10, 12, 14, 17, 20, 23, 26, 28],
  country: [0, 2, 5, 7, 10, 12, 14, 17, 20, 23, 26, 28],
  extension: [0, 1, 2, 4, 5, 7, 10, 12, 14, 15, 17, 19, 20, 23, 26, 27, 28],
  topic: [0, 1, 2, 4, 5, 7, 8, 10, 11, 12, 13, 14, 15, 17, 19, 20, 21, 22, 23, 26, 27, 28],
  loader: Array.from<number, number>(Array(29), (x: number, index: number) => index),
};

// Used for limited topic picker experiments
export const TOP_INTERESTS_FOR_US_FEMALE = [
  948264532184, // makeup
  935249274030, // home decor
  897737277903, // outfits
  950964929926, // easy recipes
  939506610041, // gift ideas
  961238559656, // art
  898977956499, // skin care
  944798509834, // diy home decor
  919296720236, // fashion
  924255633983, // food drink
  903260720461, // weddings
  948192800438, // quotes
  955506047789, // hairstyles
  919141079623, // tumblr rooms
  922203297757, // tattoos
  932986458342, // nutrition
  940939867918, // easy diy
  918644201389, // drawings
  958166992770, // coffin nails
  903884479167, // gardening
  916216778476, // casual outfits
  910924514283, // healthy recipes
  905860166503, // photography
  928401580057, // birthday
];

export const TOP_INTERESTS_FOR_US_MALE = [
  924581335376, // mens fashion
  907471527791, // diy craft
  916919860042, // gadgets
  954798921443, // survival skills
  925056443165, // animals
  950635673676, // food recipes
  922203297757, // tattoos
  899049071324, // woodworking
  905661505034, // technology
  944938374183, // health fitness
  930106275255, // funny pictures
  930020250333, // healthy eating
  894927646207, // men's hairstyles
  944798509834, // diy home decor
  924280636125, // man cave
  897906918341, // fishing
  961238559656, // art
  946765704754, // grilling recipes
];
